module.exports = __webpack_public_path__ + "static/media/wtsp_portada-01.d3eeae63.jpg";